import styled, { css } from 'styled-components';

const TextStyle = styled.div`
  font-family: Gilroy;
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
`;

const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    width: 55px;
    height: 55px;  
    border-radius: 27.5px;
    background-color: #4ca851;  
    align-items:center;  
    margin: 20px;
    ${props => props.ios && css`
        background-color: #b85e9d;
    `}
    ${props => props.verified && css`
        background-color:#4e9fdd;
    `}
`;

export default function DeviceType(props) {
    return props.device_type === "ios" ? <Wrapper ios><TextStyle>iOS</TextStyle></Wrapper> : props.device_type === "verified" ? <Wrapper verified><TextStyle>✓</TextStyle></Wrapper> : <Wrapper><TextStyle>An</TextStyle></Wrapper>
}